import Icon from '@/components/ui/AppIcon';

interface ResultCardData {
  icon: string;
  title: string;
  description: string;
  color: 'primary' | 'secondary' | 'accent' | 'success';
}

interface ResultsCardProps {
  data: ResultCardData;
}

export default function ResultsCard({ data }: ResultsCardProps) {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary border-primary/20',
    secondary: 'bg-secondary/10 text-secondary border-secondary/20',
    accent: 'bg-accent/10 text-accent border-accent/20',
    success: 'bg-success/10 text-success border-success/20',
  };

  return (
    <div className={`p-6 border-2 rounded-lg ${colorClasses[data.color]}`}>
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <Icon name={data.icon as any} size={32} className="text-current" />
        </div>
        <div className="flex-1">
          <h4 className="text-lg font-semibold mb-2">{data.title}</h4>
          <p className="text-sm opacity-90">{data.description}</p>
        </div>
      </div>
    </div>
  );
}